import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=23448e9c&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=23448e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23448e9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23448e9c')) {
      api.createRecord('23448e9c', component.options)
    } else {
      api.reload('23448e9c', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=23448e9c&scoped=true&", function () {
      api.rerender('23448e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SwBIqHg4LGK4/JS/comp/DateRangeExt.vue"
export default component.exports